import Reflux from "reflux";
import { qualifyUrl } from "util/URLUtils";
import UserNotification from "util/UserNotification";
import fetch from "logic/rest/FetchProvider";
import { singletonStore, singletonActions } from "logic/singleton";
export const TrafficLimitViolationConfigActions = singletonActions(
  "TrafficLimitViolationConfig",
  () => Reflux.createActions({
    getConfig: { asyncResult: true },
    updateConfig: { asyncResult: true }
  })
);
export const TrafficLimitViolationConfigStore = singletonStore(
  "TrafficViolationConfig",
  () => Reflux.createStore({
    listenables: [TrafficLimitViolationConfigActions],
    _state: {
      emailRecipients: void 0
    },
    getInitialState() {
      const { emailRecipients } = this._state;
      return {
        emailRecipients
      };
    },
    updateConfig(config) {
      const url = qualifyUrl("/plugins/org.graylog.plugins.license/licenses/traffic-limit-violations/settings");
      const promise = fetch("PUT", url, config);
      promise.then(
        () => this.getConfig(),
        (error) => {
          UserNotification.error(
            `Saving Traffic violation limit configuration failed with status: ${error}`,
            "Could not save Traffic violation limit configuration"
          );
        }
      );
      TrafficLimitViolationConfigActions.updateConfig.promise(promise);
      return promise;
    },
    getConfig() {
      const url = qualifyUrl("/plugins/org.graylog.plugins.license/licenses/traffic-limit-violations/settings");
      const promise = fetch("GET", url);
      promise.then((response) => {
        this.trigger({ emailRecipients: response.email_recipients });
      }).catch((error) => {
        UserNotification.error(
          `Fetching Traffic violation limit configuration failed with status: ${error}`,
          "Could not load Traffic violation limit configuration"
        );
      });
      TrafficLimitViolationConfigActions.getConfig.promise(promise);
      return promise;
    }
  })
);
